export const classes = {
  destructive:
    'text-red-3 hover:bg-red-2/10 dark:text-red-2 dark:hover:bg-red-2/20',
  label: 'text-sm font-medium',
  icon: 'mr-3 size-[1.125rem] text-taupe-2 dark:text-mauve-2',
  destructiveIcon: 'text-red-3 dark:text-red-2',
  endIcon: 'ml-3 size-[1.125rem]',
};
